<!-- 商品列表 -->
<template>
  <div
    class="ticket_page"
    :class="this.$root.isVersion ? '' : 'noversion'"
  >
    <!-- 页面展示内容 -->
    <van-pull-refresh
      v-model="refreshing"
      @refresh="onRefresh"
    >
      <!-- 项目介绍 -->
      <ProjectIntroduct
        v-show="isTopText"
        :content="topText"
        :is_collapse="isCollapse"
      ></ProjectIntroduct>
      <TitleComponent
        v-if="false"
        :title="'选择分类'"
      />
      <!-- 选择分类 -->
      <div
        v-if="false"
        class="pick_class_wrap"
      >
        <van-cell-group>
          <van-cell
            v-for="(item, index) of currentClassData"
            :key="item.uid"
            :title="item.title"
            :value="item.label"
            is-link
            @click="
              () => {
                handlePickClass(item, index)
              }
            "
          />
        </van-cell-group>
      </div>
      <TitleComponent :title="titleText" />
      <!-- 商品列表 -->
      <van-list
        v-model="loading"
        :error.sync="error"
        :finished="finished"
        :loading-text="$t('ticket.load.loading')"
        :finished-text="''"
        :error-text="$t('ticket.load.error')"
        @load="onLoad"
        class="ticket_list_wrap"
      >
        <!-- :finished-text="$t('ticket.load.finished')" -->
        <div
          class="ticket_item"
          v-for="item of ticketList"
          :key="item.uid"
        >
          <!-- v-show="item.stock_balance !== 0 && (item.purchase_limit_begin !== 0 ? (item.purchase_limit_begin <= item.stock_balance ? true : false ) : true)" -->
          <div
            class="ticket_top"
            :style="
              `background:linear-gradient(to bottom, ${item.goods_name_bg_clolor_top} 0%, ${item.goods_name_bg_clolor_bottom} 100%)`
            "
            @click="handleProDetail(item)"
          >
            <div class="ticket_name_wrap">
              <div
                class="ticket_name"
                v-show="item.is_show_goods_name"
                :style="
                  `color: ${
                    item.goods_name_color ? item.goods_name_color : '#fff'
                  }`
                "
              >
                {{ item.goods_name }}
              </div>
              <div
                class="ticket_desc"
                :style="
                  `color: ${
                    item.goods_name_color ? item.goods_name_color : '#fff'
                  }`
                "
                v-show="item.is_show_goods_name_sec"
              >
                {{ item.goods_name_sec }}
              </div>
            </div>
            <img
              v-if="item.goods_name_bg_img.length > 0"
              :src="item.cover_img"
              alt="ticket_img"
              class="ticket_img"
            />
          </div>

          <div class="ticket_footer">
            <div class="ticket_footer_top">
              <div class="ticket_price">
                <div
                  class="new_price"
                  :class="!item.is_show_origin_price ? 'only_new_price' : ''"
                >
                  <span class="price_icon">{{ saleOptions.currency }}</span>{{ item.price }}
                </div>
                <div
                  v-if="item.is_show_origin_price"
                  class="old_price"
                >
                  {{ saleOptions.currency }}{{ item.origin_price }}
                </div>
              </div>
              <div class="ticket_stepper">
                <van-stepper
                  disable-input
                  :min="0"
                  :max="
                    item.purchase_limit_max !== 0
                      ? item.purchase_limit_max < item.stock_balance
                        ? item.purchase_limit_max
                        : item.stock_balance
                      : item.stock_balance
                  "
                  v-model="item.quantity"
                  :step="
                    item.purchase_limit_step > 0 ? item.purchase_limit_step : 1
                  "
                  @plus="
                    () => {
                      changeStepperPlus(item)
                    }
                  "
                  @minus="
                    () => {
                      changeStepperMinus(item)
                    }
                  "
                />
              </div>
            </div>
            <van-divider
              v-show="
                item.is_show_goods_detail_button || item.is_show_stock_balance
              "
              class="ticket_price_divider"
            />
            <div
              class="ticket_footer_bottom"
              v-show="
                item.is_show_goods_detail_button || item.is_show_stock_balance
              "
              :class="
                !item.is_show_goods_detail_button
                  ? 'ticket_footer_bottom_flex'
                  : ''
              "
            >
              <div
                class="ticket_surplus"
                v-if="item.is_show_stock_balance"
              >
                {{$t('ticket.ticket.surplus')}}<span class="ticket_surplus_num">{{
                  item.stock_balance
                }}</span>
              </div>
              <div
                class="ticket_details"
                v-if="item.is_show_goods_detail_button"
                :class="
                  !item.is_show_stock_balance ? 'ticket_details_center' : ''
                "
                @click="handleProDetail(item)"
              >
                {{$t('ticket.ticket.detail')}}
              </div>
            </div>
            <div
              class="ticket_overlay"
              v-show="item.is_show_overlay"
            >
              <div class="ticket_overlay_content">
                <div
                  class="ticket_overlay_text"
                  v-if="item.overlay_type !== 1"
                >
                  {{ item.overlay_text }}
                </div>
                <div
                  class="ticket_overlay_timer"
                  v-else-if="item.overlay_type === 1"
                >
                  <div class="ticket_overlay_timer_text">{{$t('ticket.count.text')}}</div>
                  <van-count-down
                    class="ticket_overlay_timer_count"
                    :millisecond="false"
                    :time="item.overlay_timer"
                    :format="$t('ticket.count.format')"
                    @finish="ticketCountFinish(item)"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 底部图文 -->
        <div
          v-show="isBottomText && finished"
          class="user_diy_content_wrap"
          v-html="bottomText"
        ></div>
      </van-list>
    </van-pull-refresh>

    <!-- 分类选择器 -->
    <van-popup
      v-model="showClassPicker"
      round
      position="bottom"
      z-index="2005"
      :style="{ height: 'auto' }"
    >
      <van-picker
        title="标题"
        show-toolbar
        :columns="columns"
        @confirm="onConfirm"
        @cancel="onCancel"
      />
    </van-popup>

    <!-- 商品详情内容 -->
    <ProductDetail
      :show="showProDetail"
      :content="currentProDetail"
      :title="currentProName"
      @listenCloseDetail="handleCloseDetail"
    ></ProductDetail>

    <!-- 内容提示 -->
    <CusDialog
      :show="isEffective"
      :info="effectContent"
      @listenCloseDialog="wannaloseDialog"
    />

    <!-- 版权 -->
    <PCopyright
      v-show="this.$root.isVersion"
      class="copyright_item"
    />

  </div>
</template>

<script>
import TitleComponent from '@c/titleComponent'
import PCopyright from '@c/PCopyright'
import ProductDetail from './components/productDetail'
import ProjectIntroduct from './components/ProIntro'
import CusDialog from './components/CusDialog.vue'
import { ObjectDeepClone } from '@a/js/utils'

import { GetTicketList } from '@a/js/api/ticket.js'
import apiObj from '@a/js/api.js'

// wxshare
import { GetWxshareConfig } from '@a/js/api/public'
import { SetWechatShare } from '@a/js/utils'
import { Base64 } from 'js-base64'
import wx from 'weixin-js-sdk'

// mock
import classData from '../mock/class.json'
import levelData from '../mock/level.json'
import ticketList1 from '../mock/list.json'
export default {
  name: 'Ticket',
  data() {
    return {
      ticketList: [],
      classData,
      levelData,
      classPickArr: [],
      loading: true,
      error: false,
      finished: false,
      refreshing: false,
      showClassPicker: false,
      // 分类相关
      columns: [],
      currentLeval: 0,
      // 分类child数据对象
      currentClassDeep: 0,
      classChildObj: {},
      currentClassData: [],
      // 用户定义的提示信息
      isBottomText: false,
      bottomText: '',
      // 商品详情相关
      showProDetail: false,
      currentProDetail: '',
      currentProName: '',
      // 已选商品列表数据
      selectProList: [],
      // 是否显示顶部图文
      isTopText: false,
      isCollapse: 1,
      topText: '',
      // 售票设置相关配置
      saleOptions: {
        // 货币符号
        currency: '￥',
        // 是否购买多票种
        is_multi_ticket_type: 1,
        // 是否支持退票
        is_allow_refund: 0,
        // 是否跳转自定义页面
        is_submit_jump_url: 0,
        // 自定义页面链接
        submit_jump_url: '',
      },
      isEffective: false,
      effectContent: '提示内容',
      resInfo: {
        company_uid: '',
        channel_uid: '',
      },
      params: {},
      titleText: ''
    }
  },

  components: {
    TitleComponent,
    ProductDetail,
    ProjectIntroduct,
    PCopyright,
    CusDialog
  },

  watch: {
    currentClassData: {
      handler(data) {
        // console.log(data)
      },
      deep: true,
      immediate: true,
    },
    ticketList: {
      handler(data) {
        let tempArr = []
        data.map((item) => {
          if (item.quantity !== 0) {
            tempArr.push(item)
          }
        })
        this.selectProList = tempArr
        // 通知父组件数据发生变化
        this.$emit('listenSelectProChange', this.selectProList)
      },
      deep: true,
      immediate: true,
    },
    bottomText(val) {
      if (val) {
        this.resetAclick()
      }
    }
  },

  methods: {
    // 重置a标签点击事件
    resetAclick() {
      this.$nextTick(() => {
        let eles = document.getElementsByTagName('a')
        eles.forEach(ele => {
          if (ele.href) {
            ele.onclick = () => {
              window.location.href = ele.href
            }
          }
        })
      })
    },
    // 数据加载
    onLoad() {
      if (this.refreshing) {
        this.ticketList = []
        this.refreshing = false
      }

      let data = {
        account_uid: this.params.accountid,
        project_uid: this.params.projectid
      }
      GetTicketList(data, this.$root.language)
        .then((res) => {
          if (res.data.config.language && res.data.config.language != this.params.language) {
            this.$router.push({
              name: 'Ticket',
              params: {
                accountid: this.params.accountid,
                projectid: this.params.projectid,
                language: res.data.config.language
              }
            })
          }
          const config = res.data.config
          const list = res.data.ticket.list
          this.initSaleOptions(config, res.data.time)
          this.initTicketList(list, res.data.time)
          this.dealThemeOption(config)
          this.titleText = config.section_tickets_title ? config.section_tickets_title : '选择门票'
          this.$root.language = config.language ? config.language : 'zh'
          this.$i18n.locale = this.$root.language
          this.$emit('listenLoadConfig', config)
          this.loading = false
          this.finished = true

        })
        .catch(() => {
          this.loading = false
          this.finished = true
        })
    },
    // 刷新页面
    onRefresh() {
      // 清空列表数据
      this.finished = false

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true
      this.onLoad()
    },
    // ------ 选择器相关 ------
    // 展示分类选择器
    handlePickClass(item, index) {
      // console.log(item, index)
      // console.log(item.fid)
      this.columns = this.classChildObj[item.fid]
      // console.log(this.columns)
      this.showClassPicker = true
      this.currentLeval = index
      // console.log('level:' + this.currentLeval)
    },
    onConfirm(item) {
      // console.log(item, index)
      // this.classObj[this.currentLeval].value = value
      this.currentClassData[this.currentLeval].value = item.value
      this.currentClassData[this.currentLeval].label = item.text
      this.showClassPicker = false

      // 获取新的深度及待选分类

      if (this.classChildObj[item.id]) {
        this.getClassDeep(this.classChildObj[item.id]).then((res) => {
          // 处理分类选择类目
          this.resetClassPickArr(res, item).then((arr) => {
            this.currentClassData = arr

            // 处理当前分类选中数据
            // console.log(res)
            res.value.map((item, index) => {
              this.currentClassData[this.currentLeval + 1 + index].value =
                res.value[index]
              this.currentClassData[this.currentLeval + 1 + index].label =
                res.label[index]
              this.currentClassData[this.currentLeval + 1 + index].fid =
                res.fid[index]
            })
          })
        })
      } else {
        let tempdata = ObjectDeepClone(this.currentClassData)
        tempdata.splice(this.currentLeval + 1)
        this.currentClassData = tempdata
      }
    },
    onCancel() {
      // console.log('cancel')
      this.showClassPicker = false
    },
    // 重置分类选择数组
    resetClassPickArr(obj, currentItem) {
      return new Promise((resolve) => {
        // console.log(obj)
        // console.log(currentItem)
        let tempArr = []
        this.levelData.map((item, index) => {
          if (index <= this.currentLeval) {
            if (this.currentLeval === index) {
              item.value = currentItem.value
              item.label = currentItem.label
              item.fid = currentItem.fid
              // console.log(item)
              tempArr.push(item)
            } else {
              tempArr.push(item)
            }
          } else if (index <= obj.deep) {
            // console.log('index: ' + index)
            let tempIndex = this.currentLeval === 0 ? index - 1 : 0
            // console.log(tempIndex)
            item.value = obj.value[tempIndex]
            item.fid = obj.fid[tempIndex]
            item.label = obj.label[tempIndex]
            tempArr.push(item)
          }
        })
        resolve(tempArr)
      })
    },
    // 初始化分类数据
    initClassData() {
      // 处理分类选择数据
      this.initClassDeep(this.classData).then((obj) => {
        // console.log(obj)
        this.currentClassDeep = obj.deep
        this.initClassPickArr(obj).then((arr) => {
          this.currentClassData = arr
        })
      })
      // 处理分类child数据
      this.ergodicClassChild(this.classData).then((arr) => {
        let childArr = ObjectDeepClone(arr)
        Object.keys(childArr).map((key) => {
          childArr[key].map((item) => {
            item.text = item.label
            if (item.children) {
              delete item.children
            }
          })
        })
        this.classChildObj = childArr
      })
    },
    // 初始化分类选择数组
    initClassPickArr(obj) {
      return new Promise((resolve) => {
        let tempArr = []
        this.levelData.map((item, index) => {
          if (index <= obj.deep) {
            item.value = obj.value[index]
            item.fid = obj.fid[index]
            item.label = obj.label[index]
            tempArr.push(item)
          }
        })
        resolve(tempArr)
      })
    },
    // 获取深度
    getClassDeep(arr) {
      return new Promise((resolve) => {
        // console.log(arr)
        let tempobj = {
          deep: this.currentLeval,
          value: [],
          label: [],
          fid: [],
        }
          ; (function innerGetDeep(arr) {
            if (arr[0].children && arr[0].children.length > 0) {
              if (arr[0].value !== 'defaultClass') {
                tempobj.deep++
                tempobj.value.push(arr[0].id)
                tempobj.label.push(arr[0].label)
                tempobj.fid.push(arr[0].fid)
                innerGetDeep(arr[0].children)
              } else {
                innerGetDeep(arr[0].children)
              }
            } else {
              tempobj.deep++
              tempobj.value.push(arr[0].id)
              tempobj.label.push(arr[0].label)
              tempobj.fid.push(arr[0].fid)
            }
          })(arr)

        resolve(tempobj)
      })
    },
    // 初始化深度
    initClassDeep(obj) {
      return new Promise((resolve) => {
        let tempobj = {
          deep: 0,
          value: [],
          label: [],
          fid: [],
        }
          ; (function innerInitDeep(obj) {
            if (obj.children && obj.children.length > 0) {
              if (obj.value !== 'defaultClass') {
                tempobj.deep++
                tempobj.value.push(obj.id)
                tempobj.label.push(obj.label)
                tempobj.fid.push(obj.fid)
                innerInitDeep(obj.children[0])
              } else {
                innerInitDeep(obj.children[0])
              }
            } else {
              tempobj.value.push(obj.id)
              tempobj.label.push(obj.label)
              tempobj.fid.push(obj.fid)
            }
          })(obj)
        // console.log(tempobj)
        resolve(tempobj)
      })
    },
    // 遍历分类所有的children
    ergodicClassChild(data) {
      return new Promise((resolve) => {
        const queue = []
        const nodeObj = {}
        if (data !== null) {
          queue.push(data)
          while (queue.length > 0) {
            const item = queue.shift()
            if (item.children && item.children.length > 0) {
              nodeObj[item.value] = item.children
              item.children.forEach((child) => {
                queue.push(child)
              })
            }
          }
        }
        resolve(nodeObj)
      })
    },
    // 修改主题颜色
    modifyThemeColor() {
      document.body.style.setProperty('--bgColor', '#1989fa')
    },
    // ------ 查看商品详情相关 ------
    // 点击查看详情
    handleProDetail(item) {
      this.currentProDetail = item.goods_detail
      this.currentProName = item.goods_name
      this.showProDetail = true
    },
    // 关闭商品详情
    handleCloseDetail() {
      this.showProDetail = false
    },
    // 处理是否允许购买多票种
    isMultiTicket(data) {
      if (!this.saleOptions.is_multi_ticket_type) {
        this.ticketList.map((item) => {
          if (item.uid !== data.uid) {
            item.quantity = 0
          }
        })
      }
    },
    // 门票选择增加
    changeStepperPlus(item) {
      // 处理起购数量
      if (item.quantity === 0 && item.purchase_limit_begin !== 0) {
        item.quantity = item.purchase_limit_begin
      }
      // 处理是否允许购买多票种
      this.isMultiTicket(item)
    },
    // 门票选择减少
    changeStepperMinus(item) {
      // item.quantity 该方法中获取到的值是修改前的值
      if (item.purchase_limit_begin !== 0) {
        if (item.purchase_limit_begin === item.quantity) {
          item.quantity = 0
        }
        // 处理当前购买量减去步长小于最小购买量时情况
        if (
          item.quantity - item.purchase_limit_step <
          item.purchase_limit_begin
        ) {
          item.quantity = 0
        }
      }
    },
    // 初始化售票配置
    initSaleOptions(config, time) {
      this.saleOptions.currency = config.currency ? config.currency : '￥'
      this.saleOptions.is_multi_ticket_type = config.is_multi_ticket_type
      this.saleOptions.is_allow_refund = config.is_allow_refund
      this.saleOptions.is_submit_jump_url = config.is_submit_jump_url
      this.saleOptions.submit_jump_url = config.submit_jump_url

      this.$root.isJump = config.is_submit_jump_url ? 1 : 0
      this.$root.jumpUrl = config.submit_jump_url ? config.submit_jump_url : ''
      // 保存请求参数
      this.resInfo.company_uid = config.uid_b_company
      this.resInfo.channel_uid = config.uid_ch_account
      // this.$storeLocal.set('uids', this.resInfo)

      // 自定义图文内容
      this.isTopText = config.is_top_text ? true : false
      this.isCollapse = config.is_top_text_collapse
      this.isBottomText = config.is_bottom_text ? true : false
      this.topText = config.top_text ? config.top_text : ''
      this.bottomText = config.bottom_text ? config.bottom_text : ''
      // 处理是否正在售票中
      this.dealSaleOption(config, time)

      // 向父组件发布整体配置数据
      this.$emit('listenEmitTotalOption', config)
    },
    // 处理售票时间
    dealSaleOption(config, time) {
      if (config.is_active) {
        // 判断是否在售卖时间内
        if (config.is_time_range) {
          // 开启了售卖时间控制
          let start = new Date(config.time_range_begin).getTime()
          let end = new Date(config.time_range_end).getTime()
          if (time < start) {
            this.effectContent = this.$t('ticket.status.nostart')
            this.isEffective = true
          } else if (time > end) {
            this.effectContent = this.$t('ticket.status.end')
            this.isEffective = true
          }
        }
      } else {
        this.effectContent = this.$t('ticket.status.end')
        this.isEffective = true
      }
    },
    // 初始化门票列表数据
    initTicketList(list, time) {
      list.map((item) => {
        // 添加预购数量
        item.quantity = 0
        if (item.goods_name_bg_img.length > 0) {
          item.cover_img = apiObj.VUE_APP_BASE_CDN + item.goods_name_bg_img
        } else {
          item.cover_img = ''
        }

        // 判断是否设置售卖时间
        item.is_show_overlay = false
        item.overlay_type = 0 // 在售卖时间内
        if (item.is_set_purchase_time) {
          let start = new Date(
            item.purchase_time_begin.replace(/-/g, '/')
          ).getTime()
          let end = new Date(
            item.purchase_time_end.replace(/-/g, '/')
          ).getTime()
          if (time < start) {
            item.is_show_overlay = true
            item.overlay_type = 1 // 未到售票时间
            item.overlay_timer = start - time
          } else if (time > end) {
            item.is_show_overlay = true
            item.overlay_type = 2 // 超过售票时间
            item.overlay_text = this.$t('ticket.status.end')
          }
        }

        // 判断库存是否足够
        if (item.stock_balance !== 0) {
          if (item.purchase_limit_begin !== 0) {
            if (item.purchase_limit_begin > item.stock_balance) {
              item.is_show_overlay = true
              item.overlay_type = 4 // 余票不足
              item.overlay_text = this.$t('ticket.status.notenough')
            }
          }
        } else {
          item.is_show_overlay = true
          item.overlay_type = 3 // 已售罄
          item.overlay_text = this.$t('ticket.status.empty')
        }
      })
      this.ticketList = list
      // console.log(this.ticketList)
    },
    // 处理主题配置
    dealThemeOption(theme) {
      if (theme.theme && theme.theme.color && theme.theme.color.length > 0) {
        document.body.style.setProperty('--fontColor', theme.theme.color)
      }

      if (theme.theme && theme.theme.background && theme.theme.background.length > 0) {
        document.body.style.setProperty('--bgColor', theme.theme.background)
      }
    },
    // 点击遮罩
    handleOverlay() { },
    // 获取参数信息
    GetParamsData() {
      return new Promise(resolve => {
        this.params = this.$route.params;
        this.$root.language = this.params.language ? this.params.language : 'zh'
        this.$i18n.locale = this.$root.language
        resolve();
      });
    },
    // 倒计时结束
    ticketCountFinish(item) {
      this.ticketList.map((innerItem) => {
        if (innerItem.uid === item.uid) {
          innerItem.is_show_overlay = false
        }
      })
    },
    // 页面初始化获取微信分享配置
    InitGetWxShareConfig() {
      let href = window.location.href.split('#')[0]
      let resdata = {
        account_uid: this.params.accountid,
        project_uid: this.params.projectid,
        app_name: this.$AppName,
        url: Base64.encode(href),
      }
      GetWxshareConfig(resdata)
        .then((res) => {
          // console.log(res)
          if (res.data.config.appId) {
            let imgUrl = ''
            if (res.data.info.img.length > 0) {
              imgUrl = apiObj.VUE_APP_BASE_CDN + res.data.info.img
            }
            SetWechatShare(wx, res.data, href, imgUrl)
          }
        })
        .catch(() => { })
    },
    // 防止页面后退
    preventPageReBack() {
      history.pushState(null, null, document.URL)
      window.addEventListener('popstate', function () {
        history.pushState(null, null, document.URL)
      })
    },
    // 关闭提示框
    wannaloseDialog() {
      this.isEffective = false
    }
  },

  mounted() {
    // 初始化分类数据
    // this.initClassData()
    // this.modifyThemeColor()
    this.GetParamsData()
      .then(() => {
        this.onLoad()
        this.InitGetWxShareConfig()
      })
    // this.preventPageReBack()
  },
}
</script>
<style lang="less" scoped>
.ticket_page {
  position: relative;
  font-size: 14px;
  // min-height: calc(~"100vh - 110px");
  min-height: 100vh;
  background-color: #fefefe;
  box-sizing: border-box;
  padding-bottom: 110px;
  .copyright_item {
    bottom: 70px;
  }
  /deep/.van-pull-refresh__track {
    overflow: hidden;
  }
  // 分类选择
  .pick_class_wrap {
    background-color: #fff;
    margin: 25px 2px 30px;
    padding: 0 15px;
    border-radius: 4px;
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.1);
    .van-hairline--top-bottom:after,
    .van-hairline-unset--top-bottom:after {
      border-width: 0;
    }
    /deep/.van-cell {
      padding-left: 0;
      padding-right: 0;
    }
    /deep/.van-cell:not(:last-child):after {
      left: 0;
    }
    /deep/.van-cell__title,
    .van-cell__value {
      span {
        letter-spacing: 1px;
      }
    }
    /deep/.van-cell__title {
      span {
        font-weight: bold;
      }
    }
  }
  // 商品列表
  .ticket_list_wrap {
    // margin-top: 25px;
    padding: 0px 15px;
    .ticket_item {
      margin: 0 2px;
      border-radius: 4px;
      margin-bottom: 20px;
      overflow: hidden;
      box-shadow: 0 0 4px rgba(0, 0, 0, 0.1);
      // 封面
      .ticket_top {
        position: relative;
        min-height: 100px;
        background-color: var(--bgColor);
        font-size: 0;
        color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        .ticket_name_wrap {
          position: absolute;
          width: 100%;
          padding: 20px 0;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          .ticket_name {
            font-size: 16px;
            line-height: 22px;
            letter-spacing: 2px;
            padding: 0 30px;
            font-weight: bold;
            text-align: center;
          }
          .ticket_desc {
            font-size: 12px;
            line-height: 16px;
            letter-spacing: 1px;
            font-weight: bold;
            padding: 0 15px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            text-align: center;
          }
        }
        .ticket_img {
          width: 100%;
        }
      }
      // 价格
      .ticket_footer {
        padding: 0 15px;
        position: relative;
        .ticket_footer_top {
          padding: 20px 0;
          display: flex;
          .ticket_price {
            flex: 1;
            .new_price {
              font-size: 16px;
              letter-spacing: 1px;
              color: #ed4014;
              .price_icon {
                font-size: 14px;
              }
            }
            .only_new_price {
              line-height: 28px;
            }
            .old_price {
              font-size: 12px;
              text-decoration-line: line-through;
              color: #999;
              padding-left: 5px;
            }
          }
        }
        .ticket_price_divider {
          margin: 0;
        }
        .ticket_footer_bottom {
          display: flex;
          font-size: 12px;
          padding: 12px 4px;
          .ticket_surplus {
            color: #999;
            .ticket_surplus_num {
              margin-left: 5px;
            }
          }
          .ticket_details {
            flex: 1;
            text-align: right;
            // color: #0066ff;
          }
          .ticket_details_center {
            text-align: center;
          }
        }
        .ticket_footer_bottom_flex {
          .ticket_surplus {
            flex: 1;
            display: flex;
            .ticket_surplus_num {
              flex: 1;
              text-align: right;
            }
          }
        }
        // 遮罩
        .ticket_overlay {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          z-index: 79;
          background: rgba(0, 0, 0, 0.3);
          // 处理ios端
          border-bottom-left-radius: 4px;
          border-bottom-right-radius: 4px;
          .ticket_overlay_content {
            width: 100%;
            height: 100%;
            color: #fff;
            position: relative;
            .ticket_overlay_text {
              font-size: 18px;
              letter-spacing: 2px;
              position: absolute;
              top: 50%;
              left: 0;
              right: 0;
              text-align: center;
              transform: translateY(-50%);
              color: var(--fontColor);
            }
            .ticket_overlay_timer {
              position: absolute;
              top: 50%;
              left: 0;
              right: 0;
              text-align: center;
              transform: translateY(-50%);
              // color: var(--fontColor);
              .ticket_overlay_timer_text {
                font-size: 16px;
                letter-spacing: 2px;
                text-align: center;
                margin-bottom: 5px;
                color: var(--fontColor);
              }
              .ticket_overlay_timer_count {
                font-size: 16px;
                // color: #fff;
                color: var(--fontColor);
              }
            }
          }
        }
      }
    }
    // 用户自定义提示内容
    /deep/.user_diy_content_wrap {
      font-size: 14px;
      p {
        line-height: 1.2;
      }
      // span {
      //   width: 100%;
      //   display: inline-block;
      // }
      img {
        width: 100%;
      }
      strong,
      b {
        font-weight: bold;
      }
      em,
      i {
        font-style: italic;
      }
      hr {
        display: block !important;
        unicode-bidi: isolate !important;
        margin-block-start: 0.5em !important;
        margin-block-end: 0.5em !important;
        margin-inline-start: auto !important;
        margin-inline-end: auto !important;
        overflow: hidden !important;
        border-style: inset !important;
        border-width: 1px !important;
      }
      h1 {
        margin: 0.67em 0 !important;
        font-size: 2em !important;
        font-weight: bold !important;
      }
      h2 {
        margin: 0.83em 0 !important;
        font-size: 1.5em !important;
        font-weight: bold !important;
      }
      h3 {
        margin: 1.17em 0 !important;
        font-size: 1.17em !important;
        font-weight: bold !important;
      }
      h4 {
        // font-size: 12px !important;
        margin: 1.33em 0 !important;
        font-weight: bold !important;
      }
      h5 {
        margin: 1.67em 0 !important;
        font-size: 0.83em !important;
        font-weight: bold !important;
      }
      .ql-align-center {
        text-align: center;
      }
      .ql-align-right {
        text-align: right;
      }
      .ql-align-justify {
        text-align: justify;
      }
    }
  }
  /deep/.van-overlay {
    z-index: 3000;
    .wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      .effect_wrap {
        width: 85%;
        box-sizing: border-box;
        border-radius: 4px;
        padding: 20px;
        text-align: center;
        background-color: #fff;
        .effect_title {
          font-size: 16px;
        }
        .effect_content {
          padding-top: 12px;
          height: 60px;
          line-height: 60px;
          color: #646566;
          font-size: 14px;
        }
      }
    }
  }
}
.noversion {
  padding-bottom: 70px;
}
</style>
